export default {
    namespaced: true,
    state: {
        stateList: ["AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI", "WV", "WY"],
        lenUnit: ["cm", "inch"],
        weightUnit: ["g", "lbs"],
        currency: ['USD', 'CNY', 'CAD', 'EUR', 'GBP', 'AUD', 'JPY','MXP'],
        countryList: ["US", "ES", "DE", "JP", "CA", "UK", "PL"],
        pageList: [{ label: "Letter Size", value: 1 }],
        country: ["China"],
        statusList: [
            { value: 1, label: '未处理' },
            { value: 2, label: '已计费' },
            { value: 3, label: '异常' },
            { value: 5, label: '忽略异常' },
        ],
        typeList: [
            { value: 1, label: '仓库作业费' },
            { value: 2, label: '配送费' },
            { value: 3, label: '增值服务费' },
            { value: 4, label: '仓储费' },
            { value: 5, label: '包材费' },
            { value: 6, label: '调账' },
        ],
        bussinessTypeList: [
            { value: 1, label: '中转费用' },
            { value: 2, label: '一般入库' },
            { value: 3, label: '销售订单' },
            { value: 4, label: '仓储' },
            { value: 5, label: '其他' },
            { value: 6, label: '调拨' },
            { value: 7, label: '退货' },
            { value: 10, label: 'All' },
            { value: 11, label: '无来源入库' },
            { value: 20, label: '销毁单' },
        ],
        orderOneTypes: [
            { value: '1', label: 'B2C出库单' },
            { value: '2', label: '调拨出库单' },
            { value: '3', label: '退货入库单' },
            { value: '5', label: '入库单(纸箱)' },
            { value: '6', label: '入库单(集装箱)' },
            { value: '7', label: '入库单(其他)' },
            { value: '9', label: '中转入库执行单(集装箱)' },
            { value: '10', label: '中转入库执行单(纸箱)' },
            { value: '11', label: '中转出库执行单' },
            { value: '12', label: 'B2C出库取消单' },
            { value: '13', label: '事务单' },
            { value: '14', label: '调拨入库单' },
            { value: '15', label: '调拨入库单(onsite)' },
            { value: '16', label: '调拨出库单(onsite)' },
            { value: '19', label: '无来源入库' },
            { value: '20', label: '销毁单' },
        ],
        inventoryTypes: [
            { value: '0', label: 'Normal inventory' },
            { value: '1', label: 'Unsellable inventory' },
        ],
        productTypes: [
            { value: '1', label: '成品' },
            { value: '2', label: '配件' },
            { value: '3', label: '耗材' },
        ],
        billingDetailStatus: [
            { value: '0', label: '未出账' },
            { value: '-1', label: '已出账' },
        ],
        inventoryTaskOpType: [
            { value: '5', label: '初始化' },
            { value: '10', label: '采购入库' },
            { value: '11', label: '无来源入库' },
            { value: '13', label: '入库报损' },
            { value: '15', label: '入库报溢' },
            { value: '20', label: '退货接收入库' },
            { value: '30', label: '调拨入库' },
            { value: '40', label: '调拨出库' },
            { value: '60', label: '其他入库' },
            { value: '70', label: '其他出库' },
            { value: '100', label: '销售出库' },
            { value: '103', label: '库存调整入库' },
            { value: '104', label: '库存调整出库' },
            { value: '110', label: '仓库移出' },
            { value: '120', label: '仓库移入' },
            { value: '121', label: '仓库跨仓移入' },
            { value: '122', label: '仓库跨仓移出' },
        ],
        inventoryReserveSrcLabel: [
            { value: '0', label: '未知' },
            { value: '10', label: '销售订单' },
            { value: '50', label: '调拨出库' },
            { value: '60', label: '库存异动' },
            { value: '61', label: '预留单' },
            { value: '70', label: '销毁单'}
        ],
        inventoryTransportSrcLabel: [
            { value: '0', label: '未知' },
            { value: '20', label: '采购入库' },
            { value: '40', label: '退货' },
            { value: '80', label: '调拨入库单' },
        ],
        inventorySnapshotType: [
            { value: 'CAN_SALE', label: '可售库存' },
            { value: 'NO_SALE', label: '不可售库存' },
        ],
        inventoryBatchListType: [
            { value: '5', label: '未知' },
            { value: '10', label: '入库单' },
            { value: '20', label: '销售退货入库' },
            { value: '30', label: '调拨入库单' },
            { value: '60', label: '其他入库单' },
            { value: '120', label: '仓库移入' },
        ],
        inventoryBatchTaskType: [
            { value: '5', label: '库存初始化' },
            { value: '10', label: '入库单' },
            { value: '13', label: '入库单报损' },
            { value: '15', label: '入库单报溢' },
            { value: '20', label: '销售退货单' },
            { value: '30', label: '调拨入库单' },
            { value: '40', label: '调拨出库单' },
            { value: '60', label: '其他入库单' },
            { value: '70', label: '其他出库单' },
            { value: '100', label: '销售出库单' },
            { value: '110', label: '仓库移出' },
            { value: '120', label: '仓库移入' },
            { value: '121', label: '仓库跨仓移入' },
            { value: '122', label: '仓库跨仓移出' },
            { value: '103', label: '库存调整入库' },
            { value: '104', label: '库存调整出库' },
        ],
        customermanageAccountStatue: [
            { value: '0', label: '正常' },
            { value: '1', label: '欠费' },
            { value: '3', label: '冻结' },
        ],
        onshelfStatue:[
            { value: '0', label: '已预约' },
            { value: '1', label: '入库中' },
            { value: '2', label: '上架超时' },
        ],
        //日志类型
        logActions: {
            4: "tracking回写Boss",
            10: "推送附件",
            13: "库存流水回写",
            90: "失效",
            96: "FBA箱数据导入",
            100: "创建",
            150: "添加备注",
            200: "更新",
            210: "提交",
            220: "发运",
            230: "保存并提交",
            240: "撤回申请",
            250: "保存",
            260: "编辑",
            290: "卸货",
            300: "删除",
            400: "取消",
            500: "审核通过",
            560: "撤销审核",
            600: "审核拒绝",
            610: "BOSS处理",
            620: "文件导出",
            700: "审核",
            710: "已出库",
            720: "已确认",
            800: "完成",
            830: "生成箱标",
            840: "换仓操作",
            930: "推送仓库",
            1010: "调拨入库执行单回传boss",
            1020: "一键装箱",
            1030: "确认发货",
            1031: "修改发运信息",
            1040: "采购入库执行单回传",
            1046: "确认到仓",
            1050: "发运确认推送boss",
            1060: "审核通过推送boss",
            1070: "审核退回推送boss",
            1047: "到港确认",
            1073:"仓库回写"

        }
    },
    getters: {
        getStateList(state) {
            return state.stateList;
        },
        getCountryList(state) {
            return state.countryList;
        },
        getInventoryType(state) {
            return state.inventoryTypes;
        },
        getProductType(state) {
            return state.productTypes;
        },
        getLenUnitList(state) {
            return state.lenUnit;
        },
        getWeightUnitList(state) {
            return state.weightUnit;
        },
        getCurrencyList(state) {
            return state.currency;
        },
        getStatusList(state) {
            return state.statusList;
        },
        getTypeList(state) {
            return state.typeList;
        },
        getBussinessTypeList(state) {
            return state.bussinessTypeList;
        },
        getOrderOneTypes(state) {
            return state.orderOneTypes;
        },
        getPageList(state) {
            return state.pageList;
        },
        getCountry(state) {
            return state.country;
        },
        getBillingDetailStatus(state) {
            return state.billingDetailStatus;
        },
        getInventoryTaskOpType(state) {
            return state.inventoryTaskOpType;
        },
        getInventoryReserveSrcLabel(state) {
            return state.inventoryReserveSrcLabel;
        },
        getInventoryTransportSrcLabel(state) {
            return state.inventoryTransportSrcLabel;
        },
        getInventorySnapshotType(state) {
            return state.inventorySnapshotType;
        },
        getInventoryBatchListType(state) {
            return state.inventoryBatchListType;
        },
        getInventoryBatchTaskType(state) {
            return state.inventoryBatchTaskType;
        },
        getCustomermanageAccountStatue(state) {
            return state.customermanageAccountStatue;
        },
        getLogActions(state) {
            return state.logActions;
        },
        getOnshelfStatue(state) {
            return state.onshelfStatue;
        },
    },
    mutations: {
    },
    actions: {
    }
};
